export default "__VITE_ASSET__BYCgRyW4__"